var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGood(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.8195 33.4684C26.1087 33.4684 33.639 25.9763 33.639 16.7342C33.639 7.49216 26.1087 0 16.8195 0C7.53036 0 0 7.49216 0 16.7342C0 25.9763 7.53036 33.4684 16.8195 33.4684Z",
    fill: "#94D82D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9773 13.5675H12.5367C12.5367 12.4248 11.602 11.4948 10.4535 11.4948C9.30503 11.4948 8.37026 12.4248 8.37026 13.5675H6.92969C6.92969 11.6342 8.51032 10.0615 10.4535 10.0615C12.3967 10.0615 13.9773 11.6342 13.9773 13.5675Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3806 13.3931H25.94C25.94 12.2505 25.0053 11.3204 23.8568 11.3204C22.7084 11.3204 21.7736 12.2505 21.7736 13.3931H20.333C20.333 11.4598 21.9136 9.88718 23.8568 9.88718C25.8 9.88718 27.3806 11.4598 27.3806 13.3931Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8195 26.6222C13.7814 26.6222 11.3101 24.1634 11.3101 21.1407H12.7506C12.7506 23.3727 14.5754 25.1889 16.8195 25.1889C19.0636 25.1889 20.8883 23.3727 20.8883 21.1407H22.3289C22.3289 24.1634 19.8575 26.6222 16.8195 26.6222Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGood);
export default __webpack_public_path__ + "static/media/good.e1aad9ec2c3dc02abbe2cf6c750a8f8e.svg";
export { ForwardRef as ReactComponent };